import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";

export function useRequireAuth() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!auth.loading && !auth.user) {
      navigate("/login", {
        replace: true,
        state: { from: location.pathname },
      });
    }
  }, [auth.loading, auth.user, location.pathname, navigate]);

  return auth;
}
